import {useSnackbar} from "notistack";
import {ExportUnavailabilityLossesReactQuery} from "../reactQuery/UnavailabilityReactQuery";
import {
    buildDateFilterValidationMessage,
    validateAndConvertDateFilters
} from "../../../../Utils/AlarmDateFilterValidationUtils";
import {UnavailabilityChartMode} from "../utils/UnavailabilityChartUtils";

/**
 * Exportação CSV/Excel do gráfico de indisponibilidade por usina, usada pelas visões simplificada e expandida.
 * O arquivo reflete a visualização selecionada: no modo DIN é sempre a tabela detalhada da visão expandida
 * (todas as usinas e a linha Total), montada pelo backend com a mesma origem de dados do gráfico.
 */
export const useUnavailabilityLossesExport = (
    startDateTime: string | null,
    endDateTime: string | null,
    mode: UnavailabilityChartMode,
) => {
    const {enqueueSnackbar} = useSnackbar();
    const mutation = ExportUnavailabilityLossesReactQuery();

    const validateExportPeriod = (): {startDateTime: string; endDateTime: string} | null => {
        const validationResult = validateAndConvertDateFilters([
            {name: "startDateTime", condition: "starts-at", value: startDateTime || "", sort: "none"},
            {name: "endDateTime", condition: "ends-at", value: endDateTime || "", sort: "none"},
        ]);

        if (!startDateTime || !endDateTime || !validationResult.isValid) {
            enqueueSnackbar(buildDateFilterValidationMessage(validationResult.invalidFieldLabels), {variant: 'error'});
            return null;
        }

        return {
            startDateTime: validationResult.filters[0].value,
            endDateTime: validationResult.filters[1].value,
        };
    };

    return (format: "csv" | "excel") => {
        const validPeriod = validateExportPeriod();
        if (!validPeriod) return;

        mutation.mutate({format, mode, ...validPeriod});
    };
};
